/**
 * Shared utilities for drag-resize hooks (useHeaderResize, useTaskDetailLevel).
 * Common localStorage helpers and body style management.
 */

// ============================================
// localStorage helpers
// ============================================

export function loadNumber(key: string, fallback: number, min: number, max: number): number {
  try {
    const stored = localStorage.getItem(key);
    if (stored !== null) {
      const val = Number(stored);
      if (!isNaN(val) && val >= min && val <= max) return val;
    }
  } catch {}
  return fallback;
}

export function loadString<T extends string>(key: string, fallback: T, valid: T[]): T {
  try {
    const stored = localStorage.getItem(key);
    if (stored && valid.includes(stored as T)) return stored as T;
  } catch {}
  return fallback;
}

export function saveString(key: string, value: string): void {
  try { localStorage.setItem(key, value); } catch {}
}

// ============================================
// Body style management for drag / resize / pan
// ============================================

export function setDragBodyStyles(cursor: string): void {
  document.body.style.cursor = cursor;
  document.body.style.userSelect = 'none';
}

export function stopDragBodyStyles(): void {
  document.body.style.cursor = '';
  document.body.style.userSelect = '';
}
